import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import ThemeSettings from '../commun/ThemeSettings';
import Layout from '../commun/Layout';

const Edit_CompanyData = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const companyIndex = queryParams.get("index");

  const [formData, setFormData] = useState({
    companyName: '',
    address: '',
    contactPerson: '',
    city: '',
    mobileNumber: '',
    website: '',
    // Add more as needed
  });

  useEffect(() => {
    const storedCompanies = JSON.parse(localStorage.getItem('companies') || '[]');
    if (companyIndex !== null && storedCompanies[companyIndex]) {
      setFormData(storedCompanies[companyIndex]);
    }
  }, [companyIndex]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const companies = JSON.parse(localStorage.getItem('companies') || '[]');
    companies[companyIndex] = formData;
    localStorage.setItem('companies', JSON.stringify(companies));

    navigate('/CompanyList', { state: { success: 'Company updated successfully' } });
  };


  return (
    <>
      <div className="main-wrapper">
        <Layout />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-md-12">


                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title mb-0"> Edit Corporate Registration</h4>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>

                      <h4 className="card-title">Personal Information</h4>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="companyName">Name of The Company</label>
                            <input type="text" className="form-control" id="companyName" placeholder="Name of The Company" value={formData.companyName}
                              onChange={(e) => setFormData({ ...formData, companyName: e.target.value })} required />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="address">Address</label>
                            <textarea id="address" rows="2" className="form-control" placeholder="Address" value={formData.address}
                              onChange={(e) => setFormData({ ...formData, address: e.target.value })} ></textarea>
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="firstName">Contact Person First Name</label>
                            <input type="text" className="form-control" id="firstName" placeholder="First Name" value={formData.firstName}
                              onChange={(e) => setFormData({ ...formData, firstName: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="middleName">Middle Name</label>
                            <input type="text" className="form-control" id="middleName" placeholder="Middle Name" value={formData.middleName}
                              onChange={(e) => setFormData({ ...formData, middleName: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="lastName">Last Name</label>
                            <input type="text" className="form-control" id="lastName" placeholder="Last Name" value={formData.lastName}
                              onChange={(e) => setFormData({ ...formData, lastName: e.target.value })} />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="state">State</label>
                            <input type="text" className="form-control" id="state" placeholder="State" value={formData.state}
                              onChange={(e) => setFormData({ ...formData, state: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="country">Country</label>
                            <input type="text" className="form-control" id="country" placeholder="Country" value={formData.country}
                              onChange={(e) => setFormData({ ...formData, country: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="city">City</label>
                            <input type="text" className="form-control" id="city" placeholder="City" value={formData.city}
                              onChange={(e) => setFormData({ ...formData, city: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="pinCode">Pin Code</label>
                            <input type="text" className="form-control" id="pinCode" placeholder="Pin Code" value={formData.pinCode}
                              onChange={(e) => setFormData({ ...formData, pinCode: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="companyWebsite">Company Website</label>
                            <input type="text" className="form-control" id="companyWebsite" placeholder="Company Website" value={formData.companyWebsite}
                              onChange={(e) => setFormData({ ...formData, companyWebsite: e.target.value })} />
                          </div>
                        </div>
                      </div>

                      <h4 className="card-title">Contact Information</h4>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="mobileNumber">Mobile Number</label>
                            <input type="text" className="form-control" id="mobileNumber" placeholder="Mobile Number" value={formData.mobileNumber}
                              onChange={(e) => setFormData({ ...formData, mobileNumber: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="telephoneNumber">Telephone Number</label>
                            <input type="text" className="form-control" id="telephoneNumber" placeholder="Telephone Number" value={formData.telephoneNumber}
                              onChange={(e) => setFormData({ ...formData, telephoneNumber: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="extension">Extension</label>
                            <input type="text" className="form-control" id="extension" placeholder="Extension" value={formData.extension}
                              onChange={(e) => setFormData({ ...formData, extension: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="dob">Date of Birth</label>
                            <input type="date" className="form-control" id="dob" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="gender">Gender</label>
                            <select id="gender" className="form-control form-select">
                              <option>Select Gender</option>
                              <option>Male</option>
                              <option>Female</option>
                              <option>Other</option>
                            </select>
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="email">Email</label>
                            <input type="email" className="form-control" id="email" placeholder="Email" value={formData.email}
                              onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="password">Password</label>
                            <input type="password" className="form-control" id="password" placeholder="Password" value={formData.password}
                              onChange={(e) => setFormData({ ...formData, password: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="confirmPassword">Confirm Password</label>
                            <input type="password" className="form-control" id="confirmPassword" placeholder="Confirm Password" value={formData.confirmPassword}
                              onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })} />
                          </div>
                        </div>
                      </div>

                      <h4 className="card-title">Company Details</h4>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="gstNumber">GST Number</label>
                            <input type="text" className="form-control" id="gstNumber" placeholder="GST Number" value={formData.gstNumber}
                              onChange={(e) => setFormData({ ...formData, gstNumber: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="panNumber">PAN Number</label>
                            <input type="text" className="form-control" id="panNumber" placeholder="PAN Number" value={formData.panNumber}
                              onChange={(e) => setFormData({ ...formData, panNumber: e.target.value })} />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="companyLogo">Company Logo</label>
                            <input type="file" className="form-control" id="companyLogo" value={formData.companyLogo}
                              onChange={(e) => setFormData({ ...formData, companyLogo: e.target.value })} />
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="pmsCode">PMS Code</label>
                            <input type="text" className="form-control" id="pmsCode" placeholder="PMS Code" value={formData.pmsCode}
                              onChange={(e) => setFormData({ ...formData, pmsCode: e.target.value })} />
                          </div>
                        </div>
                      </div>

                      <h4 className="card-title">Additional Information</h4>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="marketSegment">Market Segment</label>
                            <select id="marketSegment" className="form-control form-select">
                              <option>Select Market Segment</option>
                            </select>
                          </div>
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="businessSource">Business Source</label>
                            <select id="businessSource" className="form-control form-select">
                              <option>Select Business Source</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label" htmlFor="billingInstructions">Billing Instructions</label>
                            <select id="billingInstructions" className="form-control form-select">
                              <option>Select Billing Instructions</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="text-end">
                        <button type="submit" className="btn btn-primary">Submit</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ThemeSettings />
    </>
  )
}

export default Edit_CompanyData;
